"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportPlanUpdatedActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useTransportPlanActivityTableData_1 = require("../hooks/useTransportPlanActivityTableData");
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    tableHeadCell: {
        background: theme.palette.background.paper,
        height: 24,
        padding: 0,
    },
    tableBodyCell: {
        height: 24,
        padding: 0,
    },
    tableHeadText: {
        fontSize: theme.typography.body2.fontSize,
    },
}));
const TransportPlanUpdatedActivity = ({ feed }) => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { columnNames, rows } = (0, useTransportPlanActivityTableData_1.useTransportPlanActivityTableData)(feed);
    if (!feed) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Table, { size: "small", padding: "none", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.TableHead, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.TableRow, { children: columnNames.map((columnName) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.TableCell, { rowBorders: false, className: classes.tableHeadCell, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "subtitle1", color: "textSecondary", className: classes.tableHeadText, children: translate(columnName) }) }, columnName))) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.TableBody, { children: rows.map((row) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.TableRow, { children: row.map((value) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.TableCell, { rowBorders: false, className: classes.tableBodyCell, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", color: "textSecondary", children: value }) }, value))) }, row[1]))) })] }));
};
exports.TransportPlanUpdatedActivity = TransportPlanUpdatedActivity;
//# sourceMappingURL=TransportPlanUpdatedActivity.js.map